import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import type { InputSignal, Signal } from '@angular/core';

/**
 * File Upload Counter Component
 * Can be used inside file upload component to display the number of files selected via content projection
 * Or separately since it has no dependencies on the file upload component
 */
@Component({
  selector: 'td-wb-file-upload-counter',
  template: `
    @if (quantity() > 0) {
    <ng-container>
      <div aria-live="polite">
        <span class="td-wb-file-upload-counter td-wb-file-upload-counter__bold"
              [innerText]="quantity()"
              [attr.aria-label]="quantity()"></span>
        <span class="td-wb-file-upload-counter"
              [translate]="message()"
              [attr.aria-label]="message()|translate"></span>
      </div>
    </ng-container>
    }
  `,
  styleUrls: ['file-upload-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule]
})
export class FileUploadCounterComponent {
  quantity: InputSignal<number> = input<number>();
  message?: Signal<string> = computed<string>(() => this.quantity() > 1 ? 'tdWb.fileUpload.COUNT_MANY' : 'tdWb.fileUpload.COUNT_ONE');
}
